import React from 'react'
import PropTypes from 'prop-types'
import { StyledModal } from './component.styles'
import ModalHeader from 'components/ModalHeader'
import ModalIntro from 'components/ModalIntro'
import ModalFooter from 'components/ModalFooter'

const HostAllStaffModal = ({
  flowLabel,
  handleClose,
  handleNextButtonClick,
  hasApiError,
  modals,
}) => {
  const currentModal = modals?.[0] || {}
  const { cancelLabel, helpCopy, nextLabel } = currentModal

  return (
    !!modals && (
      <StyledModal
        dataTestId="host-all-staff-modal"
        isModalOpen={true}
        modalClose={() => handleClose}
      >
        <ModalHeader
          flowLabel={flowLabel}
          handleClose={handleClose}
          showBackButton={false}
        />
        <ModalIntro modalData={currentModal} />
        <ModalFooter
          cancelButtonText={cancelLabel}
          handleCancelButtonClick={handleClose}
          handleNextButtonClick={handleNextButtonClick}
          hasApiError={hasApiError}
          helpCopy={helpCopy}
          isSubmitting={false}
          isValid={true}
          modalName="host-all-staff"
          nextButtonText={nextLabel}
          showCancelButton={false}
        />
      </StyledModal>
    )
  )
}

HostAllStaffModal.propTypes = {
  flowLabel: PropTypes.string,
  handleClose: PropTypes.func,
  handleNextButtonClick: PropTypes.func,
  hasApiError: PropTypes.bool,
  modals: PropTypes.array,
}

export default HostAllStaffModal
